import React from "react";
import { graphql } from "react-apollo";
import { getSessionInformation } from "./User";

/**
 * Helper component that allows to easily query the session information from the cache.
 * 
 * One top of that, it provides 2 functions: wrapBusiness and wrapOffice. These functions add business and office ids to the object specified.
 * This is used to add the business and office ids to the variables of an Apollo Query. This is useful for when the user changes the selected business or office,
 * the data automatically gets reloaded when the entity subclasses a BusinessOwnedModel or OfficeOwnedModel.
 */
const SessionQuery = props => {
  const { data: { sessionInformation: sessionInfo } } = props,
    wrapBusiness = variables => { return { ...variables, business: { id: sessionInfo.currentBusiness.id } } },
    wrapOffice = variables => { return { ...variables, office: sessionInfo.currentOffice ? { id: sessionInfo.currentOffice.id } : null } };

  // Needed to prevent loading data when the session information has not yet been loaded
  if (!sessionInfo) {
    return null;
  }

  return props.children({ sessionInfo, wrapBusiness, wrapOffice });
};

export default graphql(getSessionInformation, { fetchPolicy: "cache-only" })(SessionQuery);
